import { IWholesalerField, IWholesalerOrderSystem, IWholesalerService } from '@cbgms/api'

export const wholesalerServiceToFieldValues = (services: IWholesalerService[]) =>
  services.reduce(
    (prev, curr) =>
      Object.assign(prev, {
        ServiceToggles: { ...prev.ServiceToggles, [curr.Service]: curr.Active },
        ServiceConfig: { ...prev.ServiceConfig, [curr.Service]: curr.Config }
      }),
    { ServiceToggles: {}, ServiceConfig: {} }
  )

export const wholesalerFieldsToFieldValues = (orderSystemSettings: { [k: string]: string }, WholesalerFields: IWholesalerField[]) => {
  return WholesalerFields.reduce((prev, curr) => {
    const settingExists = orderSystemSettings && orderSystemSettings[curr.Name] !== undefined

    return Object.assign(prev, {
      [curr.Name]: settingExists ? orderSystemSettings[curr.Name] : ''
    })
  }, {} as { [k: string]: string })
}

export const orderSystemsToDropdownOptions = (orderSystems: IWholesalerOrderSystem[]) =>
  orderSystems.map((system: IWholesalerOrderSystem) => ({
    key: system.Name,
    value: system.Name,
    text: system.Name
  }))

export const orderSystemFieldMapper = (orderSystem: IWholesalerOrderSystem | undefined) => {
  return orderSystem?.WholesalerFields.reduce((prev, curr) => {
    return Object.assign(prev, { [curr.Name]: curr })
  }, {} as { [k: string]: IWholesalerField })
}
